import * as Highcharts from 'highcharts';
import HighchartsAccessibility from 'highcharts/modules/accessibility';

// Initialize Highcharts accessibility module globally
HighchartsAccessibility(Highcharts);

export class HighchartsConfig {
  static applyHighchartsConfig() {
    // Set global options for Highcharts
    Highcharts.setOptions({
      chart: {
        style: {
          fontFamily: 'Fidelity Sans, sans-serif', // Set default font for all charts
        },
      },
      title: {
        style: {
          fontFamily: 'Fidelity Sans, sans-serif',
        },
      },
      xAxis: {
        labels: {
          style: {
            fontFamily: 'Fidelity Sans, sans-serif',
          },
        },
      },
      yAxis: {
        labels: {
          style: {
            fontFamily: 'Fidelity Sans, sans-serif',
          },
        },
      },
      legend: {
        title: {
          style: {
            fontFamily: 'Fidelity Sans, sans-serif',
          },
        },
        itemStyle: {
          fontFamily: 'Fidelity Sans, sans-serif',
        },
      },
      tooltip: {
        style: {
          fontFamily: 'Fidelity Sans, sans-serif',
        },
      },
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
        },
      },
    });
  }
}
